export default __webpack_public_path__ + "static/media/11.BODEGA_BURRION.eaa48dcc.jpg";